import { motion } from "framer-motion";
import { ArrowRight, CalendarCheck } from "lucide-react";
import { useI18n } from "../i18n";
import { CONTACT } from "../lib/contact";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { trackCalendar, trackWhatsApp } from "../lib/analytics";

const FinalCTA = () => {
  const { t } = useI18n();
  return (
    <section data-testid="final-cta-section" className="section-light relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 gradient-radial opacity-80" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#A60056]/40 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#A60056]/40 to-transparent" />

      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-4xl sm:text-5xl lg:text-7xl text-white text-balance leading-[1.05] tracking-tight mb-6"
        >
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#7a0040] via-[#A60056] to-[#AC1361]">{t.final.title}</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15, duration: 0.7 }}
          className="text-[#5c4a54] text-lg md:text-xl mb-10"
        >
          {t.final.subtitle}
        </motion.p>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="flex flex-col sm:flex-row gap-3 justify-center"
        >
          <a
            href={CONTACT.calendar}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackCalendar("final_cta")}
            className="btn-primary"
            data-testid="final-cta-primary"
          >
            <CalendarCheck className="w-4 h-4" />
            {t.final.cta}
            <ArrowRight className="w-4 h-4" />
          </a>
          <a
            href={CONTACT.whatsapp()}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackWhatsApp("final_cta")}
            className="btn-whatsapp-solid"
            data-testid="final-cta-whatsapp"
          >
            <WhatsAppIcon className="w-4 h-4" />
            WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
